import { createSlice } from '@reduxjs/toolkit';
import { OvertimeState } from './overtimeType';
import {
  createOvertime,
  updateOvertime,
  deleteOvertime,
  fetchOvertimeById,
  fetchAllOvertimes,
  fetchOvertimeSummary,
  fetchOvertimeByEmployeeId,
  fetchOvertimeSummaryBySupervisorHierarchy,
  fetchOvertimeBySupervisorHierarchy,

} from './overtimeAction';

// Initial state
const initialState: OvertimeState = {
  overtimes: [],
  OvertimeSummary: [],
  OvertimeByEmployee: [],
  OvertimeBySupervisor: [],             
  OvertimeSummaryBySupervisor: [],
  selectedOvertime: undefined,
  loadingStates: {
    create: false,
    update: false,
    delete: false,
    fetchSupervisor: false,
    fetchSupervisorSummary: false,
    fetchById: false,
    fetchAll: false
  },
  errors: {
    create: undefined,
    update: undefined,
    delete: undefined,
    fetchById: undefined,
    fetchSupervisor: undefined,
    fetchSupervisorSummary: undefined,
    fetchAll: undefined
  }
};

// Slice
const overtimeSlice = createSlice({
  name: 'overtime',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create Overtime
      .addCase(createOvertime.pending, (state) => {
        state.loadingStates.create = true;
        state.errors.create = undefined;
      })
      .addCase(createOvertime.fulfilled, (state, action) => {
        state.loadingStates.create = false;
        state.overtimes.push(action.payload);
      })
      .addCase(createOvertime.rejected, (state, action) => {
        state.loadingStates.create = false;
        state.errors.create = action.payload as string;
      })

      // Update Overtime
      .addCase(updateOvertime.pending, (state) => {
        state.loadingStates.update = true;
        state.errors.update = undefined;
      })
      .addCase(updateOvertime.fulfilled, (state, action) => {
        state.loadingStates.update = false;
        const index = state.overtimes.findIndex((overtime) => overtime.Id === action.payload.Id);
        if (index !== -1) {
          state.overtimes[index] = action.payload;
        }
      })
      .addCase(updateOvertime.rejected, (state, action) => {
        state.loadingStates.update = false;
        state.errors.update = action.payload as string;
      })

      // Delete Overtime
      .addCase(deleteOvertime.pending, (state) => {
        state.loadingStates.delete = true;
        state.errors.delete = undefined;
      })
      .addCase(deleteOvertime.fulfilled, (state, action) => {
        state.loadingStates.delete = false;
        state.overtimes = state.overtimes.filter((overtime) => overtime.Id !== action.payload.Id);
      })
      .addCase(deleteOvertime.rejected, (state, action) => {
        state.loadingStates.delete = false;
        state.errors.delete = action.payload as string;
      })

      // Fetch Overtime by ID
      .addCase(fetchOvertimeById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchOvertimeById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedOvertime = action.payload;
      })
      .addCase(fetchOvertimeById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })
      // Fetch Overtime by ID
      .addCase(fetchOvertimeByEmployeeId.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchOvertimeByEmployeeId.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.OvertimeByEmployee = action.payload.data;
      })
      .addCase(fetchOvertimeByEmployeeId.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })

      // Fetch All Overtimes
      .addCase(fetchAllOvertimes.pending, (state) => {
        state.loadingStates.fetchAll = true;
        state.errors.fetchAll = undefined;
      })
      .addCase(fetchAllOvertimes.fulfilled, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.overtimes = action.payload.data;
      })
      .addCase(fetchAllOvertimes.rejected, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.errors.fetchAll = action.payload as string;
      })
    builder
      // Fetch Overtime by Supervisor Hierarchy
      .addCase(fetchOvertimeBySupervisorHierarchy.pending, (state) => {
        state.loadingStates.fetchSupervisor = true;
        state.errors.fetchSupervisor = undefined;
      })
      .addCase(fetchOvertimeBySupervisorHierarchy.fulfilled, (state, action) => {
        state.loadingStates.fetchSupervisor = false;
        state.OvertimeBySupervisor = action.payload.data;
      })
      .addCase(fetchOvertimeBySupervisorHierarchy.rejected, (state, action) => {
        state.loadingStates.fetchSupervisor = false;
        state.errors.fetchSupervisor = action.payload as string;
      })

      // Fetch Overtime Summary by Supervisor Hierarchy
      .addCase(fetchOvertimeSummaryBySupervisorHierarchy.pending, (state) => {
        state.loadingStates.fetchSupervisorSummary = true;
        state.errors.fetchSupervisorSummary = undefined;
      })
      .addCase(fetchOvertimeSummaryBySupervisorHierarchy.fulfilled, (state, action) => {
        state.loadingStates.fetchSupervisorSummary = false;
        state.OvertimeSummaryBySupervisor = action.payload.data;
      })
      .addCase(fetchOvertimeSummaryBySupervisorHierarchy.rejected, (state, action) => {
        state.loadingStates.fetchSupervisorSummary = false;
        state.errors.fetchSupervisorSummary = action.payload as string;
      })

      // Fetch All Overtimes
      .addCase(fetchOvertimeSummary.pending, (state) => {
        state.loadingStates.fetchAll = true;
        state.errors.fetchAll = undefined;
      })
      .addCase(fetchOvertimeSummary.fulfilled, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.OvertimeSummary = action.payload.data;
      })
      .addCase(fetchOvertimeSummary.rejected, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.errors.fetchAll = action.payload as string;
      });
  }
});

export default overtimeSlice.reducer;
